import { Component, EventEmitter, Output } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-uploadexcelformat',
  templateUrl: './uploadexcelformat.component.html',
  styleUrls: ['./uploadexcelformat.component.css']
})
export class UploadexcelformatComponent {
  @Output() download: EventEmitter<any> = new EventEmitter();
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef) { }
  downloadFormat() {
    // this.commonService.downloadFormatObservable.next("download")
  }

  closedpop() {
    this.ref.close();
    // this.commonService.downloadFormatObservable.next("")


  }

}
